import { render } from "./AlbumChangelog.vue?vue&type=template&id=356afa7a&scoped=true"
import script from "./AlbumChangelog.vue?vue&type=script&lang=js"
export * from "./AlbumChangelog.vue?vue&type=script&lang=js"

import "./AlbumChangelog.vue?vue&type=style&index=0&id=356afa7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356afa7a"]])

export default __exports__